export default (($) => {
    console.log('UNTUCKit : Module : Accordion : loaded');
    const init = () => {
        console.log('UNTUCKit : Module : Accordion : init');
        $('.js-accordion-toggle').on('click', function () {
            $(this).siblings('.js-accordion-content').slideToggle();
            $(this).toggleClass('active');
        });
    };
    return { init };
})($);
